package es.subastia.navigation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.Stable
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update

@Composable
expect fun BindBackHandler(isEnabled: Boolean, onBack: () -> Unit)

@Stable
class Navigator {
    private val _backstack = MutableStateFlow<List<NavRoute>>(listOf(NavRoute.Splash))
    val backstack: StateFlow<List<NavRoute>> = _backstack.asStateFlow()

    fun navigateTo(route: NavRoute) {
        _backstack.update { it + route }
    }

    fun pop() {
        _backstack.update { if (it.size > 1) it.dropLast(1) else it }
    }

    fun replaceAll(route: NavRoute) {
        _backstack.value = listOf(route)
    }

    fun replaceAll(routes: List<NavRoute>) {
        if (routes.isNotEmpty()) {
            _backstack.value = routes
        }
    }
}
